import React from 'react';

import { PropTypes } from 'prop-types';

import { ListItem, ListItemIcon, ListItemText } from '@mui/material';

import { CheckCircle2 } from 'lucide-react';

import { COLORS } from '../../../Constant/COLORS';

import { TypoPoppins } from '../../../Components/Typo';
import { FONTS_Poppins } from '../../../Constant/FONTS';

const ListItemCalender = ({ title, children }) => (
  <ListItem
    disableGutters
    alignItems='flex-start'
    sx={{ '.MuiListItemText-secondary': { fontFamily: FONTS_Poppins } }}
  >
    <ListItemIcon sx={{ minWidth: { xs: '40px', md: '48px' }, mt: '2px' }}>
      <CheckCircle2 color={COLORS.teal} strokeWidth={1.8} />
    </ListItemIcon>

    <ListItemText
      primary={
        <TypoPoppins variant='subtitle1' fontWeight={600} color={COLORS.ink}>
          {title}
        </TypoPoppins>
      }
      secondary={
        <TypoPoppins variant='caption' sx={{ color: COLORS.inkSoft }}>
          {children}
        </TypoPoppins>
      }
    />
  </ListItem>
);

ListItemCalender.propTypes = {
  title: PropTypes.string,
  children: PropTypes.node,
};

export default ListItemCalender;
